export const GLPYHS = {
  bullet: '•',
  openQuotes: '“',
  closeQuotes: '”',
  enter: '⏎',
  command: '⌘',
  control: 'Ctrl',
};
